import { Game } from './Game';

const game = Game.getInstance();
game.start();
